// pages/admin/Support.jsx
import React from 'react';
import AdminSupportPage from '../../components/admin/AdminSupportPage';

const Support = () => {
  return <AdminSupportPage />;
};

export default Support;